// START_MODULE theme_themeproviderstyledcomponents_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React from 'react';
import { ThemeProvider } from 'styled-components';

import { theme } from './theme';

import { IChildren } from 'utils/interfaces/IChildren';

const ThemeProviderStyledComponents: React.FC<IChildren> = ({ children }) => (
  <ThemeProvider theme={theme}>
    {children}
  </ThemeProvider>
);

export default ThemeProviderStyledComponents;

// END_MODULE theme_themeproviderstyledcomponents_tsx
